<template>
  <span>{{ $n(priceDiff, 'currency') }} {{ $t('base.priceType', priceTypeKey) }}</span>
</template>

<script>
import { mapState } from 'pinia';
import offersHelper from '@/utils/helpers/offers';
import { useServiceStore } from '@/stores';

export default {
  name: 'price-diff',
  props: {
    offer: Object,
    demand: Object,
  },
  computed: {
    ...mapState(useServiceStore, ['servicesPrice']),
    priceDiff() {
      return Math.round((this.generatedPrice - this.ceiling) * 100) / 100;
    },
    generatedPrice() {
      return offersHelper.getPrice(this.offer, this.exclTax) + this.servicesPrice;
    },
    ceiling() {
      return offersHelper.getRepaymentCeiling(this.offer);
    },
    exclTax() {
      return this.demand.show_price_ht;
    },
    priceTypeKey() {
      return this.demand.priceTypeKey;
    },
  },
};
</script>
